import RolesPermissions from './RolesPermissions';

export default RolesPermissions;
